import React, { createContext, useContext, useState, useCallback } from "react";
import { fileUrl } from "../lib/api";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const DEFAULT_TERMS = {
  messages: "TRANSMISSIONS",
  network: "RÉPLA",
  connection: "CONNEXION AU NODE",
  contact: "IDENTITÉ",
  online: "NODE CONNECTÉ",
  feeds: "FLUX",
  conversations: "TRANSMISSIONS",
};

export function applyThemeVars(theme) {
  if (!theme) return;
  const root = document.documentElement;
  const map = {
    "--r-void": theme.color_void,
    "--r-panel": theme.color_panel,
    "--r-surface": theme.color_surface,
    "--r-primary": theme.color_primary,
    "--r-secondary": theme.color_secondary,
    "--r-accent": theme.color_accent || theme.color_primary,
    "--r-alert": theme.color_alert,
    "--r-text": theme.color_text,
    "--r-text-muted": theme.color_text_muted,
    "--r-scanline": theme.scanline_intensity,
    "--r-font-title": theme.font_title ? `'${theme.font_title}', sans-serif` : undefined,
    "--r-font-body": theme.font_body ? `'${theme.font_body}', sans-serif` : undefined,
  };
  Object.entries(map).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") root.style.setProperty(k, String(v));
  });
  const bg = theme.background_image;
  if (bg) {
    const src = bg.startsWith("http") || bg.startsWith("data:") ? bg : fileUrl(bg);
    root.style.setProperty("--r-bg-image", `url("${src}")`);
  } else {
    root.style.setProperty("--r-bg-image", "none");
  }
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(null);
  const [terminology, setTerminology] = useState(DEFAULT_TERMS);
  const [networkName, setNetworkName] = useState("RÉPLA // COM");
  const [logo, setLogo] = useState("");
  const [hud, setHud] = useState(null);

  const setTheme = useCallback((resolved) => {
    if (!resolved) return;
    const t = resolved.theme || resolved;
    applyThemeVars(t);
    setThemeState(t);
    setTerminology({ ...DEFAULT_TERMS, ...(resolved.terminology || {}) });
    if (t.network_name) setNetworkName(t.network_name);
    setLogo(t.logo || "");
    if (resolved.hud) setHud(resolved.hud);
  }, []);

  const term = useCallback((key) => terminology[key] || key, [terminology]);

  return (
    <ThemeContext.Provider value={{ theme, terminology, term, setTheme, networkName, setNetworkName, logo, hud }}>
      {children}
    </ThemeContext.Provider>
  );
}
